(function(module) {
    'use strict';
    module
        .constant('Includes', {
            accounts: {
                include: [
                    {
                        relation: 'users',
                    },
                    {
                        relation: 'displays',
                    },
                    {
                        relation: 'apps',
                        scope: {
                            fields: ['id', 'appTemplateId', 'name', 'createdAt', 'updatedAt'],
                            include: {
                                relation: 'appTemplate',
                            },
                        },
                    },
                ],
            },
            accountTotalDisplays: {
                fields: {
                    id: true,
                    type: true,
                    subscriptions: true,
                },
                include: [
                    {
                        relation: 'displays',
                        scope: {
                            fields: ['id', 'subAccountID', 'accountId'],
                        },
                    },
                ],
            },
            users: {
                include: [
                    {
                        relation: 'account',
                    },
                    {
                        relation: 'roles',
                    },
                ],
            },
            subAccounts: {},
            apps: {
                include: [
                    {
                        relation: 'appTemplate',
                    },
                    {
                        relation: 'integration',
                    },
                ],
            },
            events: {},
            groups: {
                include: [
                    {
                        relation: 'apps',
                        scope: {
                            fields: ['id', 'appTemplateId', 'name', 'data'],
                            include: {
                                relation: 'appTemplate',
                            },
                        },

                    },
                    {
                        relation: 'playlists',
                        scope: {
                            fields: ['id', 'name', 'apps', 'duration'],
                        },
                    },
                ],
            },
            integrations: {
                include: [
                    {
                        relation: 'integrationTemplate',
                    },
                ],
            },
            displays: {
                include: [
                    {
                        relation: 'apps',
                        scope: {
                            fields: ['id', 'appTemplateId', 'name', 'data', 'settings'],
                            include: {
                                relation: 'appTemplate',
                            },
                        },
                    },
                    {
                        relation: 'groups',
                        scope: {
                            fields: ['id', 'name', 'appId', 'playlistId'],
                            include: [
                                {
                                    relation: 'apps',
                                    scope: {
                                        fields: ['id', 'appTemplateId', 'name', 'data', 'settings'],
                                        include: {
                                            relation: 'appTemplate',
                                        },
                                    },
                                },
                                {
                                    relation: 'playlists',
                                    scope: {
                                        fields: ['id', 'name', 'duration'],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        relation: 'playlists',
                        scope: {
                            fields: ['id', 'name', 'apps', 'duration'],
                        },
                    },
                ],
            },
        });

    module
        .constant('LGTimeZones', [
            {
                continent: 'Pacific',
                country: 'French Polynesia',
                city: 'Tahiti',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Adak',
            },
            {
                continent: 'Pacific',
                country: 'United States of America',
                city: 'Honolulu',
            },
            {
                continent: 'Pacific',
                country: 'French Polynesia',
                city: 'Marquesas',
            },
            {
                continent: 'Pacific',
                country: 'French Polynesia',
                city: 'Gambier',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Anchorage',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Tijuana',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Vancouver',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Dawson',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Los_Angeles',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Mazatlan',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Chihuahua',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Hermosillo',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Edmonton',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Yellowknife',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Dawson_Creek',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Denver',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Phoenix',
            },
            {
                continent: 'America',
                country: 'Belize',
                city: 'Belize',
            },
            {
                continent: 'America',
                country: 'Guatemala',
                city: 'Guatemala',
            },
            {
                continent: 'America',
                country: 'El Salvador',
                city: 'El_Salvador',
            },
            {
                continent: 'America',
                country: 'Honduras',
                city: 'Tegucigalpa',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Mexico_City',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Cancun',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Merida',
            },
            {
                continent: 'America',
                country: 'Mexico',
                city: 'Monterrey',
            },
            {
                continent: 'America',
                country: 'Nicaragua',
                city: 'Managua',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Winnipeg',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Rainy_River',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Regina',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Swift_Current',
            },
            {
                continent: 'America',
                country: 'Costa Rica',
                city: 'Costa_Rica',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Chicago',
            },
            {
                continent: 'America',
                country: 'Jamaica',
                city: 'Jamaica',
            },
            {
                continent: 'America',
                country: 'Bahamas',
                city: 'Nassau',
            },
            {
                continent: 'America',
                country: 'Haiti',
                city: 'Port-au-Prince',
            },
            {
                continent: 'America',
                country: 'Panama',
                city: 'Panama',
            },
            {
                continent: 'America',
                country: 'Peru',
                city: 'Lima',
            },
            {
                continent: 'America',
                country: 'Ecuador',
                city: 'Guayaquil',
            },
            {
                continent: 'America',
                country: 'Colombia',
                city: 'Bogota',
            },
            {
                continent: 'Pacific',
                country: 'Chile',
                city: 'Easter',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Toronto',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Nipigon',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Atikokan',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Montreal',
            },
            {
                continent: 'America',
                country: 'Cuba',
                city: 'Havana',
            },
            {
                continent: 'America',
                country: 'Cayman Islands',
                city: 'Cayman',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'New_York',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Detroit',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Kentucky',
            },
            {
                continent: 'America',
                country: 'United States of America',
                city: 'Indiana',
            },
            {
                continent: 'America',
                country: 'Venezuela',
                city: 'Caracas',
            },
            {
                continent: 'America',
                country: 'Barbados',
                city: 'Barbados',
            },
            {
                continent: 'Atlantic',
                country: 'Bermuda',
                city: 'Bermuda',
            },
            {
                continent: 'America',
                country: 'Bolivia',
                city: 'La_Paz',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Campo_Grande',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Cuiaba',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Porto_Velho',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Boa_Vista',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Manaus',
            },
            {
                continent: 'America',
                country: 'Guadeloupe',
                city: 'Guadeloupe',
            },
            {
                continent: 'America',
                country: 'Guyana',
                city: 'Guyana',
            },
            {
                continent: 'America',
                country: 'Greenland',
                city: 'Thule',
            },
            {
                continent: 'America',
                country: 'Puerto Rico',
                city: 'Puerto_Rico',
            },
            {
                continent: 'America',
                country: 'Paraguay',
                city: 'Asuncion',
            },
            {
                continent: 'America',
                country: 'Martinique',
                city: 'Martinique',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Halifax',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Glace_Bay',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Moncton',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'Blanc-Sablon',
            },
            {
                continent: 'America',
                country: 'Dominican Republic',
                city: 'Santo_Domingo',
            },
            {
                continent: 'America',
                country: 'Dominica',
                city: 'Dominica',
            },
            {
                continent: 'America',
                country: 'Saint Lucia',
                city: 'St_Lucia',
            },
            {
                continent: 'America',
                country: 'Trinidad And Tobago',
                city: 'Port_of_Spain',
            },
            {
                continent: 'America',
                country: 'Aruba',
                city: 'Aruba',
            },
            {
                continent: 'America',
                country: 'Canada',
                city: 'St_Johns',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Belem',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Fortaleza',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Recife',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Araguaina',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Maceio',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Sao_Paulo',
            },
            {
                continent: 'America',
                country: 'Greenland',
                city: 'Godthab',
            },
            {
                continent: 'America',
                country: 'Chile',
                city: 'Santiago',
            },
            {
                continent: 'America',
                country: 'Suriname',
                city: 'Paramaribo',
            },
            {
                continent: 'America',
                country: 'Uruguay',
                city: 'Montevideo',
            },
            {
                continent: 'America',
                country: 'Argentina',
                city: 'Argentina',
            },
            {
                continent: 'America',
                country: 'Argentina',
                city: 'Argentina',
            },
            {
                continent: 'America',
                country: 'Brazil',
                city: 'Noronha',
            },
            {
                continent: 'America',
                country: 'Greenland',
                city: 'Scoresbysund',
            },
            {
                continent: 'Atlantic',
                country: 'Portugal',
                city: 'Azores',
            },
            {
                continent: 'Atlantic',
                country: 'Cape Verde',
                city: 'Cape_Verde',
            },
            {
                continent: 'Africa',
                country: 'Burkina Faso',
                city: 'Ouagadougou',
            },
            {
                continent: 'Africa',
                country: 'Guinea-Bissau',
                city: 'Bissau',
            },
            {
                continent: 'Europe',
                country: 'Guernsey',
                city: 'Guernsey',
            },
            {
                continent: 'Europe',
                country: 'United Kingdom',
                city: 'London',
            },
            {
                continent: 'Africa',
                country: 'Guinea',
                city: 'Conakry',
            },
            {
                continent: 'Africa',
                country: 'Gambia',
                city: 'Banjul',
            },
            {
                continent: 'America',
                country: 'Greenland',
                city: 'Danmarkshavn',
            },
            {
                continent: 'Africa',
                country: 'Ghana',
                city: 'Accra',
            },
            {
                continent: 'Europe',
                country: 'Portugal',
                city: 'Lisbon',
            },
            {
                continent: 'Atlantic',
                country: 'Portugal',
                city: 'Madeira',
            },
            {
                continent: 'Atlantic',
                country: 'Spain',
                city: 'Canary',
            },
            {
                continent: 'Africa',
                country: 'Morocco',
                city: 'Casablanca',
            },
            {
                continent: 'Africa',
                country: 'Mali',
                city: 'Bamako',
            },
            {
                continent: 'Africa',
                country: 'Côte d\'Ivoire',
                city: 'Abidjan',
            },
            {
                continent: 'Africa',
                country: 'Senegal',
                city: 'Dakar',
            },
            {
                continent: 'Africa',
                country: 'Sierra Leone',
                city: 'Freetown',
            },
            {
                continent: 'Africa',
                country: 'Liberia',
                city: 'Monrovia',
            },
            {
                continent: 'Africa',
                country: 'Togo',
                city: 'Lome',
            },
            {
                continent: 'Atlantic',
                country: 'Iceland',
                city: 'Reykjavik',
            },
            {
                continent: 'Europe',
                country: 'Ireland',
                city: 'Dublin',
            },
            {
                continent: 'Europe',
                country: 'Belgium',
                city: 'Brussels',
            },
            {
                continent: 'Europe',
                country: 'Bosnia And Herzegovina',
                city: 'Sarajevo',
            },
            {
                continent: 'Africa',
                country: 'Benin',
                city: 'Porto-Novo',
            },
            {
                continent: 'Europe',
                country: 'Serbia',
                city: 'Belgrade',
            },
            {
                continent: 'Africa',
                country: 'Equatorial Guinea',
                city: 'Malabo',
            },
            {
                continent: 'Africa',
                country: 'Gabon',
                city: 'Libreville',
            },
            {
                continent: 'Europe',
                country: 'Gibraltar',
                city: 'Gibraltar',
            },
            {
                continent: 'Africa',
                country: 'Tunisia',
                city: 'Tunis',
            },
            {
                continent: 'Europe',
                country: 'Croatia',
                city: 'Zagreb',
            },
            {
                continent: 'Europe',
                country: 'Hungary',
                city: 'Budapest',
            },
            {
                continent: 'Europe',
                country: 'Poland',
                city: 'Warsaw',
            },
            {
                continent: 'Europe',
                country: 'Italy',
                city: 'Rome',
            },
            {
                continent: 'Europe',
                country: 'Spain',
                city: 'Madrid',
            },
            {
                continent: 'Europe',
                country: 'Montenegro',
                city: 'Podgorica',
            },
            {
                continent: 'Europe',
                country: 'Monaco',
                city: 'Monaco',
            },
            {
                continent: 'Europe',
                country: 'Macedonia, The Former Yugoslav Republic Of',
                city: 'Skopje',
            },
            {
                continent: 'Europe',
                country: 'Malta',
                city: 'Malta',
            },
            {
                continent: 'Europe',
                country: 'France',
                city: 'Paris',
            },
            {
                continent: 'Europe',
                country: 'Netherlands',
                city: 'Amsterdam',
            },
            {
                continent: 'Europe',
                country: 'Norway',
                city: 'Oslo',
            },
            {
                continent: 'Africa',
                country: 'Namibia',
                city: 'Windhoek',
            },
            {
                continent: 'Africa',
                country: 'Niger',
                city: 'Niamey',
            },
            {
                continent: 'Africa',
                country: 'Nigeria',
                city: 'Lagos',
            },
            {
                continent: 'Europe',
                country: 'Switzerland',
                city: 'Zurich',
            },
            {
                continent: 'Africa',
                country: 'Cameroon',
                city: 'Douala',
            },
            {
                continent: 'Africa',
                country: 'Republic Of The Congo',
                city: 'Brazzaville',
            },
            {
                continent: 'Africa',
                country: 'Central African Republic',
                city: 'Bangui',
            },
            {
                continent: 'Africa',
                country: 'Democratic Republic Of The Congo',
                city: 'Kinshasa',
            },
            {
                continent: 'Europe',
                country: 'Czech Republic',
                city: 'Prague',
            },
            {
                continent: 'Europe',
                country: 'Slovakia',
                city: 'Bratislava',
            },
            {
                continent: 'Europe',
                country: 'Slovenia',
                city: 'Ljubljana',
            },
            {
                continent: 'Europe',
                country: 'Sweden',
                city: 'Stockholm',
            },
            {
                continent: 'Europe',
                country: 'Denmark',
                city: 'Copenhagen',
            },
            {
                continent: 'Europe',
                country: 'Germany',
                city: 'Berlin',
            },
            {
                continent: 'Africa',
                country: 'Algeria',
                city: 'Algiers',
            },
            {
                continent: 'Europe',
                country: 'Liechtenstein',
                city: 'Vaduz',
            },
            {
                continent: 'Europe',
                country: 'Luxembourg',
                city: 'Luxembourg',
            },
            {
                continent: 'Africa',
                country: 'Chad',
                city: 'Ndjamena',
            },
            {
                continent: 'Europe',
                country: 'Vatican City',
                city: 'Vatican',
            },
            {
                continent: 'Europe',
                country: 'Albania',
                city: 'Tirane',
            },
            {
                continent: 'Africa',
                country: 'Angola',
                city: 'Luanda',
            },
            {
                continent: 'Europe',
                country: 'Austria',
                city: 'Vienna',
            },
            {
                continent: 'Europe',
                country: 'Bulgaria',
                city: 'Sofia',
            },
            {
                continent: 'Africa',
                country: 'Burundi',
                city: 'Bujumbura',
            },
            {
                continent: 'Africa',
                country: 'Botswana',
                city: 'Gaborone',
            },
            {
                continent: 'Europe',
                country: 'Russia',
                city: 'Kaliningrad',
            },
            {
                continent: 'Africa',
                country: 'Rwanda',
                city: 'Kigali',
            },
            {
                continent: 'Europe',
                country: 'Romania',
                city: 'Bucharest',
            },
            {
                continent: 'Europe',
                country: 'Greece',
                city: 'Athens',
            },
            {
                continent: 'Asia',
                country: 'Jordan',
                city: 'Amman',
            },
            {
                continent: 'Africa',
                country: 'Zambia',
                city: 'Lusaka',
            },
            {
                continent: 'Europe',
                country: 'Estonia',
                city: 'Tallinn',
            },
            {
                continent: 'Africa',
                country: 'Egypt',
                city: 'Cairo',
            },
            {
                continent: 'Africa',
                country: 'South Africa',
                city: 'Johannesburg',
            },
            {
                continent: 'Africa',
                country: 'Zimbabwe',
                city: 'Harare',
            },
            {
                continent: 'Europe',
                country: 'Moldova',
                city: 'Chisinau',
            },
            {
                continent: 'Africa',
                country: 'Malawi',
                city: 'Blantyre',
            },
            {
                continent: 'Asia',
                country: 'Israel',
                city: 'Jerusalem',
            },
            {
                continent: 'Europe',
                country: 'Finland',
                city: 'Helsinki',
            },
            {
                continent: 'Africa',
                country: 'Democratic Republic Of The Congo',
                city: 'Lubumbashi',
            },
            {
                continent: 'Asia',
                country: 'Cyprus',
                city: 'Nicosia',
            },
            {
                continent: 'Africa',
                country: 'Swaziland',
                city: 'Mbabane',
            },
            {
                continent: 'Asia',
                country: 'Syria',
                city: 'Damascus',
            },
            {
                continent: 'Asia',
                country: 'Lebanon',
                city: 'Beirut',
            },
            {
                continent: 'Europe',
                country: 'Turkey',
                city: 'Istanbul',
            },
            {
                continent: 'Europe',
                country: 'Latvia',
                city: 'Riga',
            },
            {
                continent: 'Europe',
                country: 'Lithuania',
                city: 'Vilnius',
            },
            {
                continent: 'Africa',
                country: 'Lesotho',
                city: 'Maseru',
            },
            {
                continent: 'Africa',
                country: 'Libya',
                city: 'Tripoli',
            },
            {
                continent: 'Europe',
                country: 'Ukraine',
                city: 'Kiev',
            },
            {
                continent: 'Europe',
                country: 'Ukraine',
                city: 'Uzhgorod',
            },
            {
                continent: 'Europe',
                country: 'Ukraine',
                city: 'Zaporozhye',
            },
            {
                continent: 'Africa',
                country: 'Mozambique',
                city: 'Maputo',
            },
            {
                continent: 'Asia',
                country: 'Bahrain',
                city: 'Bahrain',
            },
            {
                continent: 'Europe',
                country: 'Belarus',
                city: 'Minsk',
            },
            {
                continent: 'Europe',
                country: 'Russia',
                city: 'Moscow',
            },
            {
                continent: 'Europe',
                country: 'Russia',
                city: 'Simferopol',
            },
            {
                continent: 'Europe',
                country: 'Russia',
                city: 'Volgograd',
            },
            {
                continent: 'Asia',
                country: 'Iraq',
                city: 'Baghdad',
            },
            {
                continent: 'Africa',
                country: 'Ethiopia',
                city: 'Addis_Ababa',
            },
            {
                continent: 'Africa',
                country: 'Somalia',
                city: 'Mogadishu',
            },
            {
                continent: 'Asia',
                country: 'Saudi Arabia',
                city: 'Riyadh',
            },
            {
                continent: 'Africa',
                country: 'Eritrea',
                city: 'Asmara',
            },
            {
                continent: 'Indian',
                country: 'Madagascar',
                city: 'Antananarivo',
            },
            {
                continent: 'Africa',
                country: 'Uganda',
                city: 'Kampala',
            },
            {
                continent: 'Africa',
                country: 'Tanzania',
                city: 'Dar_es_Salaam',
            },
            {
                continent: 'Africa',
                country: 'Kenya',
                city: 'Nairobi',
            },
            {
                continent: 'Asia',
                country: 'Kuwait',
                city: 'Kuwait',
            },
            {
                continent: 'Africa',
                country: 'Sudan',
                city: 'Khartoum',
            },
            {
                continent: 'Asia',
                country: 'Yemen',
                city: 'Aden',
            },
            {
                continent: 'Indian',
                country: 'Mayotte',
                city: 'Mayotte',
            },
            {
                continent: 'Asia',
                country: 'Qatar',
                city: 'Qatar',
            },
            {
                continent: 'Asia',
                country: 'Iran',
                city: 'Tehran',
            },
            {
                continent: 'Europe',
                country: 'Russia',
                city: 'Samara',
            },
            {
                continent: 'Asia',
                country: 'Georgia',
                city: 'Tbilisi',
            },
            {
                continent: 'Asia',
                country: 'Oman',
                city: 'Muscat',
            },
            {
                continent: 'Indian',
                country: 'Mauritius',
                city: 'Mauritius',
            },
            {
                continent: 'Asia',
                country: 'United Arab Emirates',
                city: 'Dubai',
            },
            {
                continent: 'Asia',
                country: 'Armenia',
                city: 'Yerevan',
            },
            {
                continent: 'Asia',
                country: 'Azerbaijan',
                city: 'Baku',
            },
            {
                continent: 'Asia',
                country: 'Afghanistan',
                city: 'Kabul',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Yekaterinburg',
            },
            {
                continent: 'Asia',
                country: 'Turkmenistan',
                city: 'Ashgabat',
            },
            {
                continent: 'Asia',
                country: 'Tajikistan',
                city: 'Dushanbe',
            },
            {
                continent: 'Asia',
                country: 'Pakistan',
                city: 'Karachi',
            },
            {
                continent: 'Asia',
                country: 'Uzbekistan',
                city: 'Samarkand',
            },
            {
                continent: 'Asia',
                country: 'Uzbekistan',
                city: 'Tashkent',
            },
            {
                continent: 'Indian',
                country: 'Maldives',
                city: 'Maldives',
            },
            {
                continent: 'Asia',
                country: 'Sri Lanka',
                city: 'Colombo',
            },
            {
                continent: 'Asia',
                country: 'India',
                city: 'Kolkata',
            },
            {
                continent: 'Asia',
                country: 'Nepal',
                city: 'Kathmandu',
            },
            {
                continent: 'Asia',
                country: 'Bangladesh',
                city: 'Dhaka',
            },
            {
                continent: 'Asia',
                country: 'Bhutan',
                city: 'Thimphu',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Omsk',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Novosibirsk',
            },
            {
                continent: 'Asia',
                country: 'Kyrgyzstan',
                city: 'Bishkek',
            },
            {
                continent: 'Asia',
                country: 'Kazakhstan',
                city: 'Almaty',
            },
            {
                continent: 'Asia',
                country: 'Myanmar',
                city: 'Yangon',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Krasnoyarsk',
            },
            {
                continent: 'Asia',
                country: 'Vietnam',
                city: 'Ho_Chi_Minh',
            },
            {
                continent: 'Asia',
                country: 'Mongolia',
                city: 'Hovd',
            },
            {
                continent: 'Indian',
                country: 'Australia',
                city: 'Christmas',
            },
            {
                continent: 'Asia',
                country: 'Cambodia',
                city: 'Phnom_Penh',
            },
            {
                continent: 'Asia',
                country: 'Laos',
                city: 'Vientiane',
            },
            {
                continent: 'Asia',
                country: 'Thailand',
                city: 'Bangkok',
            },
            {
                continent: 'Asia',
                country: 'Indonesia',
                city: 'Jakarta',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Irkutsk',
            },
            {
                continent: 'Asia',
                country: 'Hong Kong',
                city: 'Hong_Kong',
            },
            {
                continent: 'Asia',
                country: 'Philippines',
                city: 'Manila',
            },
            {
                continent: 'Asia',
                country: 'Macao',
                city: 'Macau',
            },
            {
                continent: 'Asia',
                country: 'Mongolia',
                city: 'Ulaanbaatar',
            },
            {
                continent: 'Asia',
                country: 'Malaysia',
                city: 'Kuala_Lumpur',
            },
            {
                continent: 'Asia',
                country: 'Malaysia',
                city: 'Kuching',
            },
            {
                continent: 'Asia',
                country: 'China',
                city: 'Shanghai',
            },
            {
                continent: 'Asia',
                country: 'Singapore',
                city: 'Singapore',
            },
            {
                continent: 'Asia',
                country: 'Taiwan',
                city: 'Taipei',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Perth',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Yakutsk',
            },
            {
                continent: 'Asia',
                country: 'Timor-Leste',
                city: 'Dili',
            },
            {
                continent: 'Asia',
                country: 'Japan',
                city: 'Tokyo',
            },
            {
                continent: 'Pacific',
                country: 'Palau',
                city: 'Palau',
            },
            {
                continent: 'Asia',
                country: 'South Korea',
                city: 'Seoul',
            },
            {
                continent: 'Asia',
                country: 'North Korea',
                city: 'Pyongyang',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Adelaide',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Darwin',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Vladivostok',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Magadan',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Sakhalin',
            },
            {
                continent: 'Pacific',
                country: 'Guam',
                city: 'Guam',
            },
            {
                continent: 'Pacific',
                country: 'Papua New Guinea',
                city: 'Port_Moresby',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Hobart',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Melbourne',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Sydney',
            },
            {
                continent: 'Australia',
                country: 'Australia',
                city: 'Brisbane',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Srednekolymsk',
            },
            {
                continent: 'Pacific',
                country: 'Solomon Islands',
                city: 'Guadalcanal',
            },
            {
                continent: 'Pacific',
                country: 'New Caledonia',
                city: 'Noumea',
            },
            {
                continent: 'Pacific',
                country: 'Australia',
                city: 'Norfolk',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Kamchatka',
            },
            {
                continent: 'Asia',
                country: 'Russia',
                city: 'Anadyr',
            },
            {
                continent: 'Pacific',
                country: 'Marshall Islands',
                city: 'Kwajalein',
            },
            {
                continent: 'Pacific',
                country: 'Fiji',
                city: 'Fiji',
            },
            {
                continent: 'Pacific',
                country: 'New Zealand',
                city: 'Auckland',
            },
            {
                continent: 'Pacific',
                country: 'Samoa',
                city: 'Apia',
            },
            {
                continent: 'Pacific',
                country: 'Tonga',
                city: 'Tongatapu',
            },
            {
                continent: 'Pacific',
                country: 'Kiribati',
                city: 'Kiritimati',
            },
        ]);

    module
        .constant('SSTimeZones', [
            { zone: 'Africa/Casablanca', cities: 'Casablanca' },
            { zone: 'Universal', cities: 'CoordinatedUniversalTime' },
            { zone: 'Europe/London', cities: 'GreenwichMeanTime:Dublin,Edinburgh,Lisbon,London' },
            { zone: 'Africa/Monrovia', cities: 'Monrovia,Reykjavik' },
            { zone: 'Europe/Amsterdam', cities: 'Amsterdam,Berlin,Bern,Rome,Stockholm,Vienna' },
            { zone: 'Europe/Belgrade', cities: 'Belgrade,Bratislava,Budapest,Ljubljana,Prague' },
            { zone: 'Europe/Paris', cities: 'Brussels,Copenhagen,Madrid,Paris' },
            { zone: 'Europe/Sarajevo', cities: 'Sarajevo,Skopje,Warsaw,Zagreb' },
            { zone: 'Etc/GMT+1', cities: 'WestCentralAfrica' },
            { zone: 'Asia/Amman', cities: 'Amman' },
            { zone: 'Europe/Athens', cities: 'Athens,Bucharest,Istanbul' },
            { zone: 'Asia/Beirut', cities: 'Beirut' },
            { zone: 'Africa/Cairo', cities: 'Cairo' },
            { zone: 'Africa/Harare', cities: 'Harare,Pretoria' },
            { zone: 'Europe/Helsinki', cities: 'Helsinki,Kyiv,Riga,Sofia,Tallinn,Vilnius' },
            { zone: 'Asia/Jerusalem', cities: 'Jerusalem' },
            { zone: 'Asia/Baghdad', cities: 'Baghdad' },
            { zone: 'Asia/Kuwait', cities: 'Kuwait,Riyadh' },
            { zone: 'Europe/Minsk', cities: 'Minsk' },
            { zone: 'Europe/Moscow', cities: 'Moscow,St.Petersburg,Volgograd' },
            { zone: 'Africa/Nairobi', cities: 'Nairobi' },
            { zone: 'Asia/Tehran', cities: 'Tehran' },
            { zone: 'Asia/Muscat', cities: 'AbuDhabi,Muscat' },
            { zone: 'Asia/Baku', cities: 'Baku' },
            { zone: 'Etc/GMT+4', cities: 'CaucasusStandardTime' },
            { zone: 'America/Grenada', cities: 'PortLouis' },
            { zone: 'Asia/Tbilisi', cities: 'Tbilisi' },
            { zone: 'Asia/Yerevan', cities: 'Yerevan' },
            { zone: 'Asia/Kabul', cities: 'Kabul' },
            { zone: 'Asia/Yekaterinburg', cities: 'Ekaterinburg' },
            { zone: 'Asia/Karachi', cities: 'Islamabad,Karachi' },
            { zone: 'Asia/Tashkent', cities: 'Tashkent' },
            { zone: 'Asia/Kolkata', cities: 'Chennai,Kolkata,Mumbai,NewDelhi' },
            { zone: 'Asia/Colombo', cities: 'SriJayawardenepura' },
            { zone: 'Asia/Kathmandu', cities: 'Kathmandu' },
            { zone: 'Asia/Dhaka', cities: 'Astana,Dhaka' },
            { zone: 'Asia/Rangoon', cities: 'Yangon(Rangoon)' },
            { zone: 'Asia/Bangkok', cities: 'Bangkok,Hanoi,Jakarta' },
            { zone: 'Asia/Krasnoyarsk', cities: 'Krasnoyarsk' },
            { zone: 'Asia/Novosibirsk', cities: 'Novosibirsk' },
            { zone: 'Asia/Beijing', cities: 'Beijing,Chongqing,HongKong,Urumqi' },
            { zone: 'Asia/Irkutsk', cities: 'Irkutsk' },
            { zone: 'Asia/Kuala_Lumpur', cities: 'KualaLumpur,Singapore' },
            { zone: 'Austrailia/Perth', cities: 'Perth' },
            { zone: 'Asia/Taipei', cities: 'Taipei' },
            { zone: 'Asia/Ulaanbaatar', cities: 'Ulaanbaatar' },
            { zone: 'Asia/Tokyo', cities: 'Osaka,Sapporo,Tokyo' },
            { zone: 'Asia/Seoul', cities: 'Seoul' },
            { zone: 'Asia/Yakutsk', cities: 'Yakutsk' },
            { zone: 'Austrailia/Adelaide', cities: 'Adelaide' },
            { zone: 'Austrailia/Darwin', cities: 'Darwin' },
            { zone: 'Austrailia/Brisbane', cities: 'Brisbane' },
            { zone: 'Australia/Canberra', cities: 'Canberra,Melbourne,Sydney' },
            { zone: 'Pacific/Guam', cities: 'Guam,PortMoresby' },
            { zone: 'Australia/Hobart', cities: 'Hobart' },
            { zone: 'Asia/Vladivostok', cities: 'Vladivostok' },
            { zone: 'Asia/Magadan', cities: 'Magadan,SolomonIs.,NewCaledonia' },
            { zone: 'Pacific/Auckland', cities: 'Auckland,Wellington' },
            { zone: 'Pacific/Fiji', cities: 'Fiji,MarshallIs.' },
            { zone: 'Asia/Kamchatka', cities: 'Petropavlovsk-Kamchatsky' },
            { zone: 'Pacific/Tongatapu', cities: 'Nuku\'alofa' },
            { zone: 'Atlantic/Azores', cities: 'Azores' },
            { zone: 'Atlantic/Cape_Verde', cities: 'CapeVerdeIs.' },
            { zone: 'Etc/GMT-2', cities: 'Mid-Atlantic' },
            { zone: 'America/Argentina/Buenos_Aires', cities: 'BuenosAires' },
            { zone: 'America/Cayenne', cities: 'Cayenne' },
            { zone: 'America/Montevideo', cities: 'Montevideo' },
            { zone: 'Canada/Newfoundland', cities: 'Newfoundland' },
            { zone: 'America/Asuncion', cities: 'Asuncion' },
            { zone: 'Canada/Atlantic', cities: 'AtlanticTime(Canada)' },
            { zone: 'America/La_Paz', cities: 'Georgetown,LaPaz,SanJuan' },
            { zone: 'America/Manaus', cities: 'Manaus' },
            { zone: 'America/Santiago', cities: 'Santiago' },
            { zone: 'America/Caracas', cities: 'Caracas' },
            { zone: 'America/Bogota', cities: 'Bogota,Lima,Quito,RioBranco' },
            { zone: 'US/Eastern', cities: 'EasternTime(US&Canada)' },
            { zone: 'America/Indiana', cities: 'Indiana(East)' },
            { zone: 'US/Central', cities: 'CentralAmerica' },
            { zone: 'US/Central', cities: 'CentralTime(US&Canada)' },
            { zone: 'America/Monterrey', cities: 'Guadalajara,MexicoCity,Monterrey' },
            { zone: 'Canada/Saskatchewan', cities: 'Saskatchewan' },
            { zone: 'US/Arizona', cities: 'Arizona' },
            { zone: 'America/Chihuahua', cities: 'Chihuahua,LaPaz,Mazatlan' },
            { zone: 'US/Mountain', cities: 'MountainTime(US&Canada)' },
            { zone: 'US/Pacific', cities: 'PacificTime(US&Canada)' },
            { zone: 'America/Tijuana', cities: 'Tijuana,BajaCalifornia' },
            { zone: 'US/Alaska', cities: 'Alaska' },
            { zone: 'US/Hawaii', cities: 'Hawaii' },
            { zone: 'Pacific/Samoa', cities: 'MidwayIsland,Samoa' },
            { zone: 'Etc/GMT-12', cities: 'InternationalDateLineWest' },
        ]);

    module
        .constant('BrightSignTimeZones', [
            { value: 'EST', label: 'EST — US Eastern Time' },
            { value: 'CST', label: 'CST — US Central Time' },
            { value: 'MST', label: 'MST — US Mountain Time' },
            { value: 'PST', label: 'PST — US Pacific Time' },
            { value: 'AKST', label: 'AKST — Alaska Time' },
            { value: 'HST', label: 'HST — Hawaii-Aleutian Time with no Daylight Savings (Hawaii)' },
            { value: 'HST1', label: 'HST1 — Hawaii-Aleutian Time with Daylight Saving' },
            { value: 'MST1', label: 'MST1 — US MT without Daylight Saving Time (Arizona)' },
            { value: 'EST1', label: 'EST1 — US ET without Daylight Saving Time (East Indiana)' },
            { value: 'AST', label: 'AST — Atlantic Time' },
            { value: 'CST2', label: 'CST2 — Mexico (Mexico City)' },
            { value: 'MST2', label: 'MST2 — Mexico (Chihuahua)' },
            { value: 'PST2', label: 'PST2 — Mexico (Tijuana)' },
            { value: 'BRT', label: 'BRT — Brazil Time (Sao Paulo)' },
            { value: 'NST', label: 'NST — Newfoundland Time' },
            { value: 'AZOT', label: 'AZOT — Azores Time' },
            { value: 'GMTBST', label: 'GMTBST — London/Dublin Time' },
            { value: 'WET', label: 'WET — Western European Time' },
            { value: 'CET', label: 'CET — Central European Time' },
            { value: 'EET', label: 'EET — Eastern European Time' },
            { value: 'MSK', label: 'MSK — Moscow Time' },
            { value: 'SAMT', label: 'SAMT — Delta Time Zone (Samara)' },
            { value: 'YEKT', label: 'YEKT — Echo Time Zone (Yekaterinburg)' },
            { value: 'IST', label: 'IST — Indian Standard Time' },
            { value: 'NPT', label: 'NPT — Nepal Time' },
            { value: 'OMST', label: 'OMST — Foxtrot Time Zone (Omsk)' },
            { value: 'JST', label: 'JST — Japanese Standard Time' },
            { value: 'CXT', label: 'CXT — Christmas Island Time (Australia)' },
            { value: 'AWST', label: 'AWST — Australian Western Time' },
            { value: 'AWST1', label: 'AWST1 — Australian Western Time without Daylight Saving Time' },
            { value: 'ACST', label: 'ACST — Australian Central Standard Time (CST) with Daylight Saving Time' },
            {
                value: 'ACST1',
                label: 'ACST1 — Darwin, Australia/Darwin, and Australian Central Standard Time (CST) without Daylight Saving Time',
            },
            { value: 'AEST', label: 'AEST — Australian Eastern Time with Daylight Saving Time' },
            { value: 'AEST1', label: 'AEST1 — Australian Eastern Time without Daylight Saving Time (Brisbane)' },
            { value: 'NFT', label: 'NFT — Norfolk (Island) Time (Australia)' },
            { value: 'NZST', label: 'NZST — New Zealand Time (Auckland)' },
            { value: 'CHAST', label: 'CHAST — , Fiji Time, , Fiji, Pacific/Fiji, Yankee Time Zone (Fiji)' },
            { value: 'SST', label: 'SST — X-ray Time Zone (Pago Pago)' },
            { value: 'GMT', label: 'GMT — Greenwich Mean Time' },
            { value: 'GMT-1', label: 'GMT-1 — 1 hour behind Greenwich Mean Time' },
            { value: 'GMT-2', label: 'GMT-2 — 2 hours behind Greenwich Mean Time' },
            { value: 'GMT-3', label: 'GMT-3 — 3 hours behind Greenwich Mean Time' },
            { value: 'GMT-3:30', label: 'GMT-3:30 — 3.5 hours behind Greenwich Mean Time' },
            { value: 'GMT-4', label: 'GMT-4 — 4 hours behind Greenwich Mean Time' },
            { value: 'GMT-4:30', label: 'GMT-4:30 — 4.5 hours behind Greenwich Mean Time' },
            { value: 'GMT-5', label: 'GMT-5 — 5 hours behind Greenwich Mean Time' },
            { value: 'GMT-6', label: 'GMT-6 — 6 hours behind Greenwich Mean Time' },
            { value: 'GMT-7', label: 'GMT-7 — 7 hours behind Greenwich Mean Time' },
            { value: 'GMT-8', label: 'GMT-8 — 8 hours behind Greenwich Mean Time' },
            { value: 'GMT-9', label: 'GMT-9 — 9 hours behind Greenwich Mean Time' },
            { value: 'GMT-9:30', label: 'GMT-9:30 — 9.5 hours behind Greenwich Mean Time' },
            { value: 'GMT-10', label: 'GMT-10 — 10 hours behind Greenwich Mean Time' },
            { value: 'GMT-11', label: 'GMT-11 — 11 hours behind Greenwich Mean Time' },
            { value: 'GMT-12', label: 'GMT-12 — 12 hours behind Greenwich Mean Time' },
            { value: 'GMT-13', label: 'GMT-13 — 13 hours behind Greenwich Mean Time' },
            { value: 'GMT-14', label: 'GMT-14 — 14 hours behind Greenwich Mean Time' },
            { value: 'GMT+1', label: 'GMT+1 — 1 hour ahead of Greenwich Mean Time' },
            { value: 'GMT+2', label: 'GMT+2 — 2 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+3', label: 'GMT+3 — 3 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+3:30', label: 'GMT+3:30 — 3.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+4', label: 'GMT+4 — 4 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+4:30', label: 'GMT+4:30 — 4.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+5', label: 'GMT+5 — 5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+5:30', label: 'GMT+5:30 — 5.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+6', label: 'GMT+6 — 6 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+6:30', label: 'GMT+6:30 — 6.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+7', label: 'GMT+7 — 7 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+7:30', label: 'GMT+7:30 — 7.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+8', label: 'GMT+8 — 8 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+8:30', label: 'GMT+8:30 — 8.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+9', label: 'GMT+9 — 9 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+9:30', label: 'GMT+9:30 — 9.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+10', label: 'GMT+10 — 10 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+10:30', label: 'GMT+10:30 — 10.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+11', label: 'GMT+11 — 11 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+11:30', label: 'GMT+11:30 — 11.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+12', label: 'GMT+12 — 12 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+12:30', label: 'GMT+12:30 — 12.5 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+13', label: 'GMT+13 — 13 hours ahead of Greenwich Mean Time' },
            { value: 'GMT+14', label: 'GMT+14 — 14 hours ahead of Greenwich Mean Time' },
        ]);

})(angular.module('rocket.components'));
